package com.meistercharts.charts.pv.stringsPlanning

import kotlin.uuid.Uuid
import com.meistercharts.charts.pv.roofPlanning.Module
import it.neckar.open.observable.ObservableObject

/**
 * Represents a model for a roof planning
 */
class PvStringsPlanningModel {

  val roofStringsConfiguration: RoofStringsConfiguration = RoofStringsConfiguration()

  val selectedStringProperty: ObservableObject<RoofString?> = ObservableObject(null)
  val selectedString: RoofString? by selectedStringProperty


  fun addRoofString(roofString: RoofString) {
    roofStringsConfiguration.add(roofString)
    set(roofString.uuid)
  }

  /**
   * Selects the string with the given uuid, or clears the selection when [roofStringUuid] is null. Throws if there is no
   * string with that uuid - an unknown uuid is a bug in the caller, not a request to clear the selection.
   */
  fun set(roofStringUuid: Uuid?) {
    selectedStringProperty.value = roofStringUuid?.let { roofStringsConfiguration[it] }
  }

  fun containsModule(module: Module): Boolean {
    return roofStringsConfiguration.roofStrings.any { it.contains(module) }
  }

  /**
   * Returns the string with the given uuid. Throws if there is none.
   */
  fun getRoofString(roofStringUuid: Uuid): RoofString {
    return roofStringsConfiguration[roofStringUuid]
  }

  /**
   * Returns the string the given module belongs to, or null if the module is not wired up yet.
   */
  fun findRoofStringContaining(module: Module): RoofString? {
    return roofStringsConfiguration.roofStrings.firstOrNull { it.contains(module) }
  }

}
